import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-primary-button',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './primary-button.component.html',
  styleUrl: './primary-button.component.css'
})
export class PrimaryButtonComponent {
  @Input() text: string = '';
  @Input() href: string = '#';
  @Input() extraClasses: string = '';
  @Input() isDisabled: boolean = false;
  @Output() buttonClick = new EventEmitter<void>();

  
  backgroundColor = '#0588AD'; 

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isDisabled']) {
      this.updateBackgroundColor();
    }
  }

  updateBackgroundColor(): void {
    this.backgroundColor = this.isDisabled ? '#93989F' : '#0588AD';  
  }

  click(){
    this.buttonClick.emit();
  }

}
